import cx from 'classnames'
import { useFadingScrollbar } from 'hooks/useFadingScrollbar'
import { useState, ReactNode } from 'react'
import Styles from './ScrollContainer.module.scss'

interface ScrollContainerProps {
  children: ReactNode
  className?: string
}

const ScrollContainer = ({ children, className }: ScrollContainerProps) => {
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(null)
  useFadingScrollbar(scrollContainer)

  return (
    <div className={cx(Styles.scrollContainer, className)} ref={(el) => setScrollContainer(el)}>
      {children}
    </div>
  )
}

export { ScrollContainer }
